/**
 * logoFieldModel — o logo da página (`identity`) como dado: escolher/tirar e o ViewModel do contrato `logoField.vm.js`.
 * docs/PLANO-EXECUCAO-MIDIA.md TODO 8.1: grava `avatarAssetId` + `avatarOrigin` e limpa `avatarUrl` (o endereço antigo).
 */
import { MediaOrigin } from '../../catalogs/pageCatalog.generated.js';
import { pastaDaImagem } from '../pages/blocks/galleryBlockModel.js';

/** Foto escolhida na biblioteca (formato da Mídia) vira o logo. Só foto do dono chega aqui (modo 'logo'). */
export function escolherLogo(identity, foto) {
  return { ...identity, avatarAssetId: foto.assetId, avatarOrigin: foto.origem ?? MediaOrigin.Owner, avatarUrl: null };
}

export function tirarLogo(identity) {
  return { ...identity, avatarAssetId: null, avatarOrigin: null, avatarUrl: null };
}

/** Pixel transparente que a Api punha como "logo" de conta nova (Q5) — não é logo: conta como sem logo. */
const ehPixel = (url) => /\/pages\/templates\/hero-images\//.test(url || '');

export function montarVm(identity, donoId) {
  const id = identity?.avatarAssetId;
  const antigo = identity?.avatarUrl && !ehPixel(identity.avatarUrl) ? identity.avatarUrl : null;
  const pasta = id ? pastaDaImagem(id, identity.avatarOrigin ?? MediaOrigin.Owner, donoId) : null;
  const kind = id ? 'library' : antigo ? 'legacy' : 'none';
  return {
    label: 'Logo',
    helper: 'Aparece no topo da página. Prefira uma imagem quadrada, com fundo.',
    kind,
    thumbnailUrl: kind === 'library' ? (pasta ? `${pasta}w320.webp` : null) : kind === 'legacy' ? antigo : null,
    noticeLabel: kind === 'legacy' ? 'Logo no formato antigo — escolha de novo pela biblioteca para ficar mais leve.' : null,
    chooseLabel: kind === 'none' ? 'Escolher logo' : 'Trocar logo',
    removeLabel: kind === 'none' ? null : 'Tirar o logo',
  };
}
